module.exports = __webpack_public_path__ + "media/assets/images/blog/ha_partnership_leanbit-9aa9840aa5a3bc0ff5c9d18862825822.jpg";